/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { prism } from "react-syntax-highlighter/dist/esm/styles/prism";

// core components
import SectionCarousel from "views/ComponentsPage/Sections/SectionCarousel.js";

const exampleCarousel = `import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";

import carouselStyle from "assets/jss/material-kit-pro-react/views/componentsSections/carouselStyle.js";

import image1 from "assets/img/bg.jpg";
import image2 from "assets/img/bg2.jpg";
import image3 from "assets/img/bg3.jpg";

const useStyles = makeStyles(carouselStyle);

export default function SectionCarousel() {
  const classes = useStyles();
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  };
  return (
    <div className={classes.section} id="carousel">
      <div className={classes.container}>
        <GridContainer>
          <GridItem xs={12} sm={10} md={8} className={classes.marginAuto}>
            <Card>
              <Carousel {...settings}>
                <div>
                  <img src={image1} alt="First slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Yellowstone National Park, United States
                    </h4>
                  </div>
                </div>
                <div>
                  <img
                    src={image2}
                    alt="Second slide"
                    className="slick-image"
                  />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Somewhere Beyond, United States
                    </h4>
                  </div>
                </div>
                <div>
                  <img src={image3} alt="Third slide" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      Yellowstone National Park, United States
                    </h4>
                  </div>
                </div>
              </Carousel>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}`;

function Carousel() {
  return (
    <div>
      <h1>React Slick 0.24.0</h1>
      <h2>Styles</h2>
      <p>
        You will find the styles for this component in
        <br />
        <code>src/assets/scss/plugins/_plugin-react-slick.scss</code>.
      </p>
      <h2>Example</h2>
      <div className="border-example-8">
        <SectionCarousel />
      </div>
      <SyntaxHighlighter language="jsx" style={prism}>
        {exampleCarousel}
      </SyntaxHighlighter>
      <h2>Props</h2>
      <p>
        We've added some extra classes to the default ones from{" "}
        <a
          href="https://react-slick.neostack.com/?ref=creativetim"
          target="_blank"
        >
          react-slick
        </a>
        .
      </p>
      <p>
        These are <code>.slick-image</code> for the image of the slide,{" "}
        <code>.slick-caption</code>, the text that appears over the image and{" "}
        <code>.slick-icons</code>, used for the icon that goes along with the
        text.
      </p>
      <p>
        For more details please refer to{" "}
        <a
          href="https://react-slick.neostack.com/docs/get-started?ref=creativetim"
          target="_blank"
        >
          react-slick's official docs
        </a>
        .
      </p>
    </div>
  );
}

export default Carousel;
